import moment from 'moment';
import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Vendor Truck',
    title_book: 'Booking Truck For Booking',
    title_interchange: 'Booking Truck For Interchange',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Truck',
        href: '/adm/opr/truck',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_vendortruck',
    sortDesc: true,
    fields: [
      {
        key: 'code',
        sortable: true,
      },
      {
        key: 'vendor_name',
        label: 'Vendor Name',
        sortable: true,
      },
      {
        key: 'phone',
        label: 'Phone',
      },
      {
        key: 'address',
        label: 'Address',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_book: [
      {
        key: 'code_truck',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'date_truck',
        label: 'Date',
      },
      {
        key: 'doc_no',
        label: 'Doc No',
        sortable: true,
      },
      {
        key: 'vendor_name',
        label: 'Vendor Name',
      },
      {
        key: 'destination',
        label: 'Destination',
      },
      {
        key: 'total_price',
        label: 'Total',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    fields_interchange: [
      {
        key: 'code_truck',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'date_truck',
        label: 'Date',
      },
      {
        key: 'doc_no',
        label: 'Doc No',
        sortable: true,
      },
      {
        key: 'vendor_name',
        label: 'Vendor Name',
      },
      {
        key: 'destination',
        label: 'Destination',
      },
      {
        key: 'total_price',
        label: 'Total',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    detail: false,
    form: {
      code: '',
      name: '',
      address: '',
      phone: '',
    },
    form_truck_interchange: {
      code_principle: '',
      principle: '',
      truck_code: '',
      truck_name: '',
      doc_no: '',
      truck_from: '',
      truck_to: '',
      consignee: '',
      date_pickup: '',
      cont_size: '',
      cont_qty: '',
      cont_type: '',
      remark: '',
      destination: '',
      items_destination: [],
      list_destination: [],
    },
    form_truck_booking: {
      code_principle: '',
      principle: '',
      truck_code: '',
      truck_name: '',
      doc_no: '',
      truck_from: '',
      truck_to: '',
      shipper: '',
      date_pickup: '',
      cont_size: '',
      cont_qty: '',
      cont_type: '',
      remark: '',
      destination: '',
      items_destination: [],
      list_destination: [],
    },
    print_interchange: false,
    import_form: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  import_form(state) {
    return state.data.import_form;
  },
  form_truck_interchange(state) {
    return state.data.form_truck_interchange;
  },
  form_truck_booking(state) {
    return state.data.form_truck_booking;
  },
};

export const mutations = {
  changeTruck(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchTruck(context, params = null) {
    let result = await ApiGetRequest(`opr/vendor-truck`, params);
    return !result.error ? result.data.object : [];
  },

  async getPrice({ commit, state }, payload = null) {
    commit('changeTruck', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(
      `opr/vendor-truck-price/price/${payload.id}/${payload.cust_group}/${
        payload.cont_type
      }/${payload.cont_size}/${payload.origin ? payload.origin : '0'}`
    );

    if (payload.type === 'interchange') {
      commit('changeTruck', {
        form_truck_interchange: {
          ...data.form_truck_interchange,
          list_origin: !result.error ? result.data.object.origin : [],
          list_destination: !result.error ? result.data.object.destination : [],
          items_destination: !result.error ? result.data.object.items : [],
        },
        loading: false,
      });
    } else {
      commit('changeTruck', {
        form_truck_booking: {
          ...data.form_truck_booking,
          list_origin: !result.error ? result.data.object.origin : [],
          list_destination: !result.error ? result.data.object.destination : [],
          items_destination: !result.error ? result.data.object.items : [],
        },
        loading: false,
      });
    }

    return !result.error ? true : false;
  },

  async getListTruckInterchange({ commit, state }) {
    commit('changeTruck', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      start_date:
        data.date_filter && data.date_filter.length > 0 && data.date_filter[0]
          ? moment(data.date_filter[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        data.date_filter && data.date_filter.length > 1 && data.date_filter[1]
          ? moment(data.date_filter[1]).format('YYYY-MM-DD')
          : '',
    };

    let result = await ApiGetRequest(`opr/truck-interchange`, params);
    commit('changeTruck', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getListTruckBooking({ commit, state }) {
    commit('changeTruck', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      start_date:
        data.date_filter && data.date_filter.length > 0 && data.date_filter[0]
          ? moment(data.date_filter[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        data.date_filter && data.date_filter.length > 1 && data.date_filter[1]
          ? moment(data.date_filter[1]).format('YYYY-MM-DD')
          : '',
    };

    let result = await ApiGetRequest(`opr/truck-booking`, params);
    commit('changeTruck', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getListTruck({ commit, state }) {
    commit('changeTruck', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`opr/vendor-truck`, params);
    commit('changeTruck', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailTruck({ commit }, payload = null) {
    commit('changeTruck', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/vendor-truck/${payload.id}`);
    commit('changeTruck', {
      loading: false,
      detail: result.error ? false : result.data.object,
    });

    return result.error ? false : true;
  },

  async importData({ commit, dispatch, state }) {
    commit('changeTruck', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`opr/vendor-truck/import`, {
      items: data.import_form || [],
    });

    commit('changeTruck', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async createTruck({ state, commit, dispatch }) {
    commit('changeTruck', {
      loading: true,
    });

    let result = await ApiPostRequest(`opr/vendor-truck`, state.data.form);
    commit('changeTruck', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateTruck({ commit, state, dispatch }, payload = null) {
    commit('changeTruck', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `opr/vendor-truck/${payload.id}`,
      state.data.form
    );

    commit('changeTruck', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteTruck({ commit, dispatch }, payload = null) {
    commit('changeTruck', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/vendor-truck/${payload.id}`);
    commit('changeTruck', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async searchBooking(context, payload = null) {
    let result = await ApiGetRequest(`opr/truck-booking/search`, payload);
    if (!result.error) {
      return result.data.object || {};
    }

    return false;
  },

  async getDetailTruckBooking({ commit }, payload = null) {
    commit('changeTruck', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/truck-booking/${payload.id}`);
    commit('changeTruck', {
      loading: false,
    });

    if (!result.error) {
      commit('changeTruck', {
        form_truck_booking: {
          ...result.data.object,
          date_pickup: result.data.object.date_pickup
            ? moment(result.data.object.date_pickup).format('DD/MM/YYYY')
            : '',
          remark: result.data.object.truck_remark || '',
        },
      });

      return true;
    }

    return false;
  },

  async createTruckBooking({ commit, state, dispatch }) {
    commit('changeTruck', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(
      `opr/truck-booking`,
      data.form_truck_booking
    );

    commit('changeTruck', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateTruckBooking({ commit, state, dispatch }, payload = null) {
    commit('changeTruck', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(
      `opr/truck-booking/${payload.id}`,
      data.form_truck_booking
    );

    commit('changeTruck', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async deleteTruckBooking({ commit, dispatch }, payload = null) {
    commit('changeTruck', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/truck-booking/${payload.id}`);
    commit('changeTruck', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async searchInterchange(context, payload = null) {
    let result = await ApiGetRequest(`opr/truck-interchange/search`, payload);
    if (!result.error) {
      return result.data.object || {};
    }

    return false;
  },

  async getDetailTruckInterchange({ commit }, payload = null) {
    commit('changeTruck', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/truck-interchange/${payload.id}`);
    commit('changeTruck', {
      loading: false,
    });

    if (!result.error) {
      commit('changeTruck', {
        form_truck_interchange: {
          ...result.data.object,
          date_pickup: result.data.object.date_pickup
            ? moment(result.data.object.date_pickup).format('DD/MM/YYYY')
            : '',
          remark: result.data.object.truck_remark || '',
        },
      });

      return true;
    }

    return false;
  },

  async createTruckInterchange({ commit, state, dispatch }) {
    commit('changeTruck', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(
      `opr/truck-interchange`,
      data.form_truck_interchange
    );

    commit('changeTruck', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateTruckInterchange({ commit, state, dispatch }, payload = null) {
    commit('changeTruck', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPutRequest(
      `opr/truck-interchange/${payload.id}`,
      data.form_truck_interchange
    );

    commit('changeTruck', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async deleteTruckInterchange({ commit, dispatch }, payload = null) {
    commit('changeTruck', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/truck-interchange/${payload.id}`);
    commit('changeTruck', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
